<script lang="ts">
  import { getContext } from 'svelte';

  import { _ } from 'svelte-i18n';
  import InfiniteScroll from './InfiniteScroll.svelte';
  import Avatar from './Avatar.svelte';
  import type { Writable } from 'svelte/store';

  export let allowed_users, members, sharing_type;
  export let invited_users, users_to_invite, users_to_schedule, community;
  export let owner, club_users, allow_edit_users = false, hilight_invited = true;

  function combine_users(_me, _owner, invited, scheduled, club) {
    let sort = v=>v.sort((a, b)=> a.last_name.localeCompare(b.last_name));
    //let users = sort([...scheduled]);
    let users = [];
    //let ids = users.map(u=>u.id);
    let ids = [];
    [...sort(scheduled ?? []), ...sort((invited ?? [])), ...sort((club ?? []))].forEach(u => {
      if (!ids.includes(u.id)) {
        users.push(u);
        ids.push(u.id);
      }
    });

    // Bring session owner and your user to the front of the list.
    if (_me) {
      let me_index = users.findIndex(u=>u.id == _me.id);
      if (me_index > 0) {
        let me = users.splice(me_index, 1)[0];
        users.unshift(me);
      }
    }
    if (_owner) {
      let owner_index = users.findIndex(u=>u.id == _owner.id);
      if (owner_index > 0) {
        let owner = users.splice(owner_index, 1)[0];
        users.unshift(owner);
      }
    }
    return [...users.values()];
  } 
  let user_params: Writable<any> = getContext("user_params");
  $: all_users_raw = combine_users($user_params, owner, invited_users ?? [], members ?? [], club_users);
  $: all_users = all_users_raw.map(u=>{
      switch (sharing_type) {
        case "public":
          u.invited = false;
          break;
        case "community":
          u.invited = true;
          break;
        case "invite-only":
          u.invited = users_to_invite.includes(u.id);
          break;
      }
      u.scheduled = users_to_schedule.includes(u.id);
      return u;
    });

  function toggle_select_user(uid) {
    if (allow_edit_users) {
      let already_invited = users_to_invite.includes(uid);
      // This disables scheduling users. TODO: Re-enable for coaches.
      let already_scheduled = users_to_schedule.includes(uid);

      if (already_scheduled) {
        // Don't allow modification of scheduled users.
      } else if (already_invited) {
        users_to_invite = users_to_invite.filter(u=>u!=uid);
      } else {
        users_to_invite = [...users_to_invite, uid];
      }
    }
  }

</script>

<InfiniteScroll auto_multi={true} multi={3} viewport_height={480} item_height={88+16} item_width={340+16} items={all_users}>
  <div slot="header">
  </div>
  <user-card slot="item" let:item={user} let:index={index} class:selected={allow_edit_users && user.selected}
    class:invited={hilight_invited && user.invited}
    class:scheduled={hilight_invited && user.scheduled}
    on:click={()=>toggle_select_user(user.id)}>
    <Avatar {...user}/>
    <row-container>
    <h4 class="bold">
      {user.first_name} {user.last_name}
    </h4>

    {#if user.training_status != null}
    <span> {$_("sessions.editor.labels.training_status")} {@html user.training_status.stars} </span>
    {/if}
    </row-container>
  </user-card>
</InfiniteScroll>

<style lang="scss">
  // TODO: Figure out how to appy theme globally?
  @import './style/xert.scss';

  user-card {
    position: relative;

    &.invited, &.scheduled {
      border-color: var(--color-xert-teal);
    }
    &.scheduled {
      //background-color: var(--color-xert-lime);
      &:before {
        position: absolute;
        right: 0;
        top: 0;
        content: "\f058";
        color: var(--color-xert-lime);

        // TODO: Make a generic scss include for FontAwesome.
        font: normal normal normal 14px/1 FontAwesome;
        line-height: 1;
        font-size: 20px;
        text-rendering: auto;
        margin: 16px;

      }
    }

    --avatar-height: 56px;
    --avatar-margin: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
    margin: 9px;

    border: 1px solid #ECECECCC;
    border-radius: 5px;
  }

</style>
